import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import { useAuth } from "@/context/AuthContext";
import { Bell, Search } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";

export default function AppLayout() {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F2EE]">
        <div className="text-[#00000099]">Loading…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace state={{ from: location }} />;

  return (
    <div className="min-h-screen flex bg-[#F4F2EE]">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <header className="bg-white border-b border-[#E0DFDC] sticky top-0 z-40 h-14 flex items-center px-6 gap-4">
          <div className="relative flex-1 max-w-md">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#00000066]" />
            <input
              data-testid="top-search-input"
              placeholder="Search students, batches, faculty…"
              className="w-full pl-9 pr-4 py-2 rounded-md bg-[#EDEBE7] border border-transparent focus:border-[#0A66C2] focus:bg-white text-sm outline-none"
            />
          </div>
          <button data-testid="top-notifications-btn" className="relative p-2 rounded-full hover:bg-[#00000010]">
            <Bell size={18} />
            <span className="absolute top-1 right-1 w-2 h-2 bg-[#CC1016] rounded-full" />
          </button>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-[#EAF3FB] text-[#0A66C2] flex items-center justify-center text-sm font-semibold">
              {user?.name?.[0] || "U"}
            </div>
            <div className="hidden sm:block leading-tight">
              <div className="text-[13px] font-semibold" data-testid="header-user-name">{user?.name}</div>
              <div className="text-[11px] text-[#00000099]">{user?.email}</div>
            </div>
          </div>
        </header>

        <main className="flex-1 overflow-y-auto p-6 fade-up">
          <Outlet />
        </main>
      </div>
      <Toaster position="top-right" richColors />
    </div>
  );
}
